type RecommendedBadgeProps = {
  size?: number;
  marginRight?: number;
  marginLeft?: number;
  /** 親要素が選択状態のとき true にするとバッジが primary で塗られる
   *  (選択中表示は primary 系に統一。生成実行ボタンのみ accent)。 */
  active?: boolean;
};

export function RecommendedBadge({ size = 12, marginRight = 4, marginLeft = 0, active = false }: RecommendedBadgeProps) {
  return (
    <span
      role="img"
      aria-label="推奨"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        marginRight,
        marginLeft,
        verticalAlign: 'middle',
        transform: 'translateY(-1px)',
        flexShrink: 0,
        backgroundColor: active
          ? 'var(--brand-primary)'
          : 'currentColor',
        WebkitMaskImage: 'url("/check_badge.svg")',
        maskImage: 'url("/check_badge.svg")',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  );
}
